<template>
  <div>
    <MemberLayout :disabledPadding="true">
      <div>
        <div v-if="isLoaded">
          <iframe :src="getPaymentPgaeURL" width="100%" class="iframe">
          </iframe>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import { getCurrentUser, getBusinessMonth } from "../../api/fordaysHelpers";
export default {
  name: "OrderPaymentScreen",
  components: {
    MemberLayout,
  },
  data() {
    return {
      isLoaded: false,
      user: {},
      month: null,
      cartDocId: null,
      hostURL: "https://fordays-backend-official.herokuapp.com",
      // 測試環境相關
      testHostURL: "https://083b-36-231-117-188.ngrok.io",
      testEnv: false, // 是測試環境嗎？預設是false
    };
  },
  computed: {
    getPaymentPgaeURL() {
      if (!this.testEnv) {
        return `${this.hostURL}/payment/purchase?cartDocId=${this.cartDocId}&enabled_new_gift=1`;
      } else {
        return `${this.testHostURL}/payment/purchase-testing?cartDocId=${this.cartDocId}&enabled_new_gift=1`;
      }
    },
  },
  methods: {
    receiveMessage(event) {
      // const vm = this;
      const postMessageObject = JSON.parse(event.data);
      if ("postDataType" in postMessageObject) {
        const paymentURL3D = postMessageObject.paymentURL3D;
        window.location = paymentURL3D;
      }

      // const postMessageObject = JSON.parse(event.data);
      // const paymentStatus = postMessageObject.paymentStatus;
      // const paymentData = postMessageObject.paymentData;
      // const jselloutCode = postMessageObject.jselloutCode;
      // if (paymentStatus === 0) {
      //   alert("付款成功");
      //   vm.$router.push({
      //     name: "OrderFinishedScreen",
      //     params: {
      //       paymentData: paymentData,
      //       jselloutCode: jselloutCode,
      //       cartDocId: vm.cartDocId,
      //     },
      //   });
      // }
    },
  },
  mounted() {
    const vm = this;
    async function fetchData() {
      const cartDocId = vm.$route.params["cartDocId"];
      // 取得User
      const user = await getCurrentUser();
      // 取得營業月份
      const businessMonth = getBusinessMonth();
      vm.user = user;
      vm.isLoaded = true;
      vm.month = businessMonth;
      vm.cartDocId = cartDocId;
    }
    fetchData();
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
};
</script>
<style lang="scss" scoped>
.iframe {
  width: 100%;
  // 扣掉header 45px 與 navbar 50px
  height: calc(100vh - 45px - 50px);
  border: none;
}
</style>